import { contributorFullName } from '@/foundations/helpers/contributorName';

export default [
  {
    name: 'exercises',
    icon: 'mdi-bulletin-board',
    routes: ['list', 'edit', 'create'],
  },
  {
    name: 'categories',
    icon: 'mdi-cards',
    routes: ['list', 'show', 'edit', 'create'],
  },
  {
    name: 'publishers',
    label: (r) => `${r.name}`,
    icon: 'mdi-bank',
    routes: ['list', 'show', 'edit', 'create'],
  },
  {
    name: 'languages',
    label: (r) => `${r.language} (${r.languageCode})`,
    icon: 'mdi-web',
    routes: ['list', 'show', 'edit', 'create'],
  },
  {
    name: 'series',
    icon: 'mdi-bookshelf',
    routes: ['list', 'show', 'edit', 'create'],
  },
  {
    name: 'areas',
    icon: 'mdi-view-grid',
    routes: ['list', 'show', 'edit', 'create'],
  },
  {
    name: 'keywords',
    icon: 'mdi-key',
    routes: ['list', 'edit', 'create'],
  },
  {
    name: 'contributors',
    label: contributorFullName,
    icon: 'mdi-account-edit',
    routes: ['list', 'edit', 'create'],
  },
  {
    name: 'translations',
    icon: 'mdi-translate',
    routes: ['list'],
  },
  {
    name: 'content',
    icon: 'mdi-book-open',
    routes: ['list', 'show', 'edit'],
  },
  {
    name: 'audio-fragments',
    icon: 'mdi-music',
    label: 'Audio Fragments',
    translatable: true,
    include: {
      contentType: 'AudioFragment',
      path: 'audio-fragments',
    },
    routes: ['list', 'show', 'edit', 'create'],
  },
  {
    name: 'content-image',
    label: 'Image',
    translatable: true,
    include: {
      contentType: 'Image',
      path: 'image',
    },
    icon: 'mdi-file-image',
    routes: ['list', 'show', 'edit', 'create'],
  },
  {
    name: 'books',
    label: (r) => `${r.title} (${r.isbn})`,
    translatable: true,
    include: {
      contentType: 'Book',
      path: 'books',
    },
    icon: 'mdi-book-open-page-variant',
    routes: ['list', 'edit', 'create'],
  },
  {
    name: 'materials',
    translatable: true,
    include: {
      contentType: 'Material',
      path: 'materials',
    },
    icon: 'mdi-clipboard-text',
    routes: ['list', 'edit', 'create'],
  },
  {
    name: 'collections',
    api: 'collections',
    translatable: true,
    include: {
      contentType: 'Collections',
      path: 'collections',
    },
    icon: 'mdi-folder-open',
    routes: ['list', 'edit', 'create', 'show'],
  },
  {
    name: 'collections-us',
    api: 'collections_us',
    translatable: true,
    include: {
      contentType: 'Collections',
      path: 'collections',
    },
    icon: 'mdi-folder-open',
    routes: ['edit', 'create', 'show'],
  },
  {
    name: 'views',
    api: 'views',
    translatable: true,
    include: {
      contentType: 'Views',
      path: 'views',
    },
    icon: 'mdi-camera-burst',
    routes: ['list', 'edit', 'create', 'show'],
  },
  {
    name: 'articles',
    translatable: true,
    include: {
      contentType: 'Article',
      path: 'articles',
    },
    icon: 'mdi-owl',
    routes: ['list', 'edit', 'show', 'create'],
  },
  {
    name: 'giglets-books',
    translatable: true,
    include: {
      contentType: 'GigletsBook',
      path: 'GigletsBook',
    },
    icon: 'mdi-book-open-blank-variant',
    routes: ['list', 'show'],
  },
  {
    name: 'scopes',
    icon: 'mdi-security',
    routes: ['list', 'delete'],
    // permissions: ["admin"],
  },
  {
    name: 'book-talk',
    icon: 'mdi-chat-question',
    routes: ['list'],
  },
  {
    name: 'reading-competitions',
    icon: 'mdi-trophy-variant',
    routes: ['list', 'edit', 'create', 'show'],
  },
  {
    name: 'videos',
    include: {
      contentType: 'Video',
      path: 'videos',
    },
    icon: 'mdi-movie-play',
    routes: ['list', 'edit', 'create'],
  },
  {
    name: 'curriculum-goals',
    translatable: true,
  },

  {
    name: 'metadata',
  },
  {
    name: 'parse',
  },
];
